import { trigger, transition, style, animate } from '@angular/animations';

export const fadeSlideAnimation = trigger('fadeSlide', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('320ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
    ]),
    transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-5px)' }))
    ])
]);